function hideTemplateVariantInputs() {
  document
    .querySelectorAll('input[id*="-template-"][type="radio"], input[id*="-template-"][type="checkbox"]')
    .forEach(function (el) {
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');
    });
}

document.addEventListener('DOMContentLoaded', hideTemplateVariantInputs);
new MutationObserver(hideTemplateVariantInputs).observe(document.documentElement, {
  childList: true,
  subtree: true
});
